import React from "react";
import {VFlex} from "components/_defaultComponents/Flex/VFlex";
import {
    CompanyFilter,
    SubCompanyFilter,
    DateRangeOrPeriodFilterWithCheckbox,
    TransactionTypeFilter,
    FeeTypeFilter,
    WalletStatusFilter,
    ProviderCompanyFilter,
    CreditModeFilter
} from "components/_defaultComponents/FilterComponents";
import {useStore} from "hooks/useStore";
import WorkingTypeFilter from "components/_defaultComponents/FilterComponents/WorkingTypeFilter";
import {useFetch} from "hooks/useFetch";
import {FiltersRow, FilterColumn} from "../styles/CreditLog.styles";
import InvoiceStatusFilter from "components/_defaultComponents/FilterComponents/InvoiceStatusFilter";

const CreditLogFilters = ({
    setSelectedTransactionType,
    setSelectedSubType,
    setSelectedHasWalletTransaction,
    setSelectedDateRange,
    setIsDateRangeChecked,
    setSelectedPeriod,
    setIsPeriodChecked,
    setSelectedCompanyId,
    setSelectedSubCompanyId,
    selectedTransactionType,
    selectedSubType,
    selectedHasWalletTransaction,
    selectedDateRange,
    isDateRangeChecked,
    selectedPeriod,
    isPeriodChecked,
    companyId,
    subCompanyId,
    workType,
    setSelectedWorkType,
    selectedInvoiceStatus,
    setSelectedInvoiceStatus,
    selectedProviderCompany,
    setSelectedProviderCompany,
    selectedCreditMode,
    setSelectedCreditMode
}) => {
    const stores = useStore();

    const [paymentPeriodLoading, paymentPeriods] = useFetch({
        fetchFn: stores.paymentPeriodStore.paymentPeriodWithNames.bind(),
        dependencies: [],
        initialCall: true
    });

    return (
        <FiltersRow>
            <FilterColumn $minWidth={140}>
                <VFlex vertical gap={4}>
                    <div style={{minHeight: 22}}>
                        <h5>Çalışma Tipi</h5>
                    </div>
                    <WorkingTypeFilter
                        value={workType}
                        onChange={setSelectedWorkType}
                        hideTitle
                    />
                </VFlex>
            </FilterColumn>
            <FilterColumn $minWidth={140}>
                <VFlex vertical gap={4}>
                    <div style={{minHeight: 22}}>
                        <h5>Firma</h5>
                    </div>
                    <CompanyFilter
                        value={companyId}
                        onChange={value => {
                            setSelectedCompanyId(value);
                            setSelectedSubCompanyId(undefined);
                        }}
                        showAllOption={true}
                        allKey="all"
                        disabled={false}
                        hideTitle
                    />
                </VFlex>
            </FilterColumn>
            <FilterColumn $minWidth={140}>
                <VFlex vertical gap={4}>
                    <div style={{minHeight: 22}}>
                        <h5>Alt Firma</h5>
                    </div>
                    <SubCompanyFilter
                        value={subCompanyId}
                        onChange={setSelectedSubCompanyId}
                        company={companyId === "all" ? undefined : companyId}
                        initialCall={!!companyId && companyId !== "all"}
                        disabled={!companyId || companyId === "all"}
                        showAllOption={true}
                        allowClear
                        hideTitle
                    />
                </VFlex>
            </FilterColumn>
            <FilterColumn $minWidth={280} $flex="2 1 0">
                <VFlex vertical gap={4}>
                    <DateRangeOrPeriodFilterWithCheckbox
                        paymentPeriods={paymentPeriods || []}
                        dateRangeChecked={isDateRangeChecked}
                        periodChecked={isPeriodChecked}
                        onDateRangeCheckChange={setIsDateRangeChecked}
                        onPeriodCheckChange={setIsPeriodChecked}
                        dateRangeValue={selectedDateRange}
                        onDateRangeChange={setSelectedDateRange}
                        periodValue={selectedPeriod}
                        onPeriodChange={setSelectedPeriod}
                        dateRangePlaceholder={["Başlangıç Tarihi", "Bitiş Tarihi"]}
                        periodPlaceholder="Dönem Seçiniz"
                        dateRangeFormat="YYYY-MM-DD"
                    />
                </VFlex>
            </FilterColumn>
            <FilterColumn $minWidth={140}>
                <VFlex vertical gap={4}>
                    <div style={{minHeight: 22}}>
                        <h5>İşlem Türü</h5>
                    </div>
                    <TransactionTypeFilter
                        value={selectedTransactionType}
                        onChange={value => {
                            setSelectedTransactionType(value);
                            setSelectedSubType([]);
                        }}
                        hideTitle
                        showAllOption={false}
                        mode="multiple"
                        placeholder="İşlem Türü"
                        allowClear
                    />
                </VFlex>
            </FilterColumn>
            {stores.meStore.checkRole("isAdmin") ? (
                <>
                    <FilterColumn $minWidth={140}>
                        <VFlex vertical gap={4}>
                            <div style={{minHeight: 22}}>
                                <h5>Ücret Tipi</h5>
                            </div>
                            <FeeTypeFilter
                                value={selectedSubType}
                                onChange={setSelectedSubType}
                                hideTitle
                                showAllOption={false}
                                mode="multiple"
                                placeholder="Ücret Tipi"
                                allowClear
                            />
                        </VFlex>
                    </FilterColumn>
                    <FilterColumn $minWidth={140}>
                        <VFlex vertical gap={4}>
                            <div style={{minHeight: 22}}>
                                <h5>Cüzdan Durumu</h5>
                            </div>
                            <WalletStatusFilter
                                value={selectedHasWalletTransaction}
                                onChange={setSelectedHasWalletTransaction}
                                hideTitle
                            />
                        </VFlex>
                    </FilterColumn>
                </>
            ) : null}
            <FilterColumn $minWidth={140} $capWidth={160}>
                <VFlex vertical gap={4}>
                    <div style={{minHeight: 22}}>
                        <h5>Fatura Durumu</h5>
                    </div>
                    <InvoiceStatusFilter
                        value={selectedInvoiceStatus}
                        onChange={setSelectedInvoiceStatus}
                    />
                </VFlex>
            </FilterColumn>
            <FilterColumn $minWidth={140} $capWidth={160}>
                <VFlex vertical gap={4}>
                    <div style={{minHeight: 22}}>
                        <h5>Sağlayıcı Firma</h5>
                    </div>
                    <ProviderCompanyFilter
                        value={selectedProviderCompany}
                        onChange={setSelectedProviderCompany}
                        hideTitle
                    />
                </VFlex>
            </FilterColumn>
            <FilterColumn $minWidth={140} $capWidth={160}>
                <VFlex vertical gap={4}>
                    <div style={{minHeight: 22}}>
                        <h5>Kredi Modu</h5>
                    </div>
                    <CreditModeFilter
                        value={selectedCreditMode}
                        onChange={setSelectedCreditMode}
                        hideTitle
                        showAllOption={false}
                        mode="multiple"
                        placeholder="Kredi Modu"
                        allowClear
                    />
                </VFlex>
            </FilterColumn>
        </FiltersRow>
    );
};

export default CreditLogFilters;
